import logger from 'lc-logger';
import appConfig from 'lc-app-config';
import { useEffect } from 'react';
import ResourceCenterService from '../../services/resource-center';
import styles from '../../styles/main.module.scss';
import BlogHome from '../../components/blogHome/blogHome';
import XrayMode from '../../components/xrayMode/xrayMode';
import trackHeapEvent from '../../services/helpers/trackHeapEvent';
import csrf from '../../services/helpers/csrf';
import {
  errorFilter,
  getOptimizelyUserExperiments,
} from '../../services/helpers/common';

export default function Home({
  blogHomeData,
  isPreview = false,
  spaceId,
  entryId,
  experiments,
}) {
  useEffect(() => {
    trackHeapEvent(
      { Title: 'Page Load', Page: blogHomeData.hub },
      'CMS_Unification',
      experiments
    );
  }, [blogHomeData, experiments]);
  return (
    <main className={styles.main}>
      {isPreview && spaceId && (
        <XrayMode
          title={blogHomeData.pageTitle ?? 'Content'}
          spaceId={spaceId}
          entryId={entryId}
        />
      )}
      <BlogHome {...blogHomeData} />
    </main>
  );
}

export async function getServerSideProps(context) {
  const hub = 'Resource Center';
  const userVariation = getOptimizelyUserExperiments(context.req.headers);

  const resourceCenterService = new ResourceCenterService(context.preview);
  const props = await resourceCenterService.getHomePage(hub, userVariation);
  if (!props) {
    logger.info(
      {
        statusCode: 404,
        hub,
      },
      'LC-WEBSITE: Hub home page not found'
    );
    return {
      notFound: true,
    };
  }
  logger.info(
    {
      statusCode: 200,
      hub,
    },
    'LC-WEBSITE: Generating home page for Hub'
  );
  const spaceId = appConfig.get('CONTENTFUL_SPACE_ID');
  let csrfToken = '';
  try {
    csrfToken = await csrf(context.req, context.res);
  } catch (err) {
    logger.info(
      { hub },
      'LC-WEBSITE: Error in generating csrf. Error: ',
      errorFilter(err)
    );
  }

  return {
    props: {
      ...props,
      isPreview: !!context.preview,
      spaceId,
      csrfToken,
      experiments: Object.fromEntries(userVariation),
    },
  };
}
